const HTML_FALLBACK = /^\s*(<!doctype html|<html)/i;

export function validateSchedule(schedule, activeManagers = []) {
  if (!schedule || !Array.isArray(schedule.weeks)) {
    return { ok: false, errors: ['Schedule must contain a weeks array.'] };
  }

  const errors = [];
  const expected = new Set(activeManagers);

  schedule.weeks.forEach((weekEntry) => {
    if (!Number.isInteger(weekEntry.week) || weekEntry.week < 1) {
      errors.push('Every schedule week must have a positive integer week number.');
      return;
    }

    const seen = new Set();
    (weekEntry.matchups || []).forEach((matchup) => {
      if (!matchup.home || !matchup.away || matchup.home === matchup.away) {
        errors.push(`Week ${weekEntry.week} contains an invalid matchup.`);
        return;
      }

      [matchup.home, matchup.away].forEach((manager) => {
        if (seen.has(manager)) errors.push(`Week ${weekEntry.week} lists ${manager} more than once.`);
        if (expected.size > 0 && !expected.has(manager)) errors.push(`Week ${weekEntry.week} contains unknown manager ${manager}.`);
        seen.add(manager);
      });
    });

    expected.forEach((manager) => {
      if (!seen.has(manager)) errors.push(`Week ${weekEntry.week} is missing ${manager}.`);
    });
  });

  return { ok: errors.length === 0, errors };
}

export async function loadSchedule(year, fetchImpl = fetch) {
  const response = await fetchImpl(`/data/schedules/${year}.json`);
  if (!response.ok) return null;

  const text = await response.text();
  if (!text || HTML_FALLBACK.test(text)) return null;

  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export function matchupsForWeek(schedule, week) {
  return schedule?.weeks?.find((entry) => entry.week === week)?.matchups || [];
}
